// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2076":"common","4121":"vendor","5179":"components"}[chunkId] + "/bundle." + {"2076":"80133535","4121":"39c3ff0a","5179":"4bc3ff4c"}[chunkId] + ".js";
};